"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBackButton = exports.defaultBackButton = void 0;
var _react = require("react");
var defaultBackButton = exports.defaultBackButton = {};
var useBackButton = exports.useBackButton = function useBackButton(calculated, previousPathname) {
  var backButton = (0, _react.useMemo)(function () {
    if (calculated) {
      return {
        to: previousPathname,
        mode: 'calculated'
      };
    }
    return undefined;
  }, [calculated, previousPathname]);
  return backButton;
};